(function() {
    var BookingFilter = function($el) {
        this.$el = $el
        this.checkboxes = this.$el.find('input[type=checkbox]')
        this.applyBtn = this.$el.find('.js-booking-filter__apply')
        this.openBtn = this.$el.find('.js-booking-filter__open')
        this.optionslist = this.$el.find('.js-booking-filter__list')
        this.selectedlist = this.$el.find('.js-booking-filter__selected')
        this.selectedtemplate = Handlebars.compile(this.$el.find('.js-booking-filter__selected-template').html())
        this.title = this.$el.data('title')
        this.fieldName = this.$el.data('fieldName') + '[]'

        this.bindEvents()
        this.renderSelectedList()

        return this
    }

    BookingFilter.prototype.bindEvents = function () {
        this.openBtn.on('click', this.toggleOptionsList.bind(this))
        this.applyBtn.on('click', this.toggleOptionsList.bind(this))
        this.checkboxes.on('change', this.renderSelectedList.bind(this))
        this.checkboxes.on('change', this.updateUrl.bind(this))
    }

    BookingFilter.prototype.getSelectedOptions = function () {
        return this.checkboxes.filter(':checked')
    }

    BookingFilter.prototype.getSelectedOptionsDisplayValues = function () {
        return this.getSelectedOptions()
            .map(function(){
                return $(this).data('displayValue')
            })
            .toArray()
    }

    BookingFilter.prototype.renderSelectedList = function (event) {
        var viewData = {
            title: this.title,
            selected: this.getSelectedOptionsDisplayValues()
        }

        this.selectedlist.html(this.selectedtemplate(viewData))
    }

    BookingFilter.prototype.updateUrl = function (event) {
        var url = new URL(window.location)
        var fieldName = this.fieldName //scope variable for "each" closure

        url.searchParams.delete(fieldName);

        this.getSelectedOptions().each(function() {
            url.searchParams.append(fieldName, this.value)
        })
        
        history.replaceState({}, '', url.toString())
    }

    BookingFilter.prototype.toggleOptionsList = function (event) {
        event.preventDefault()

        this.optionslist.toggle()
    }

    $('.js-booking-filter').each(function () {
        new BookingFilter($(this))
    })
})()
